// test484
(484 && 0);
